import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, footer, testId = "modal" }) {
  if (!open) return null;
  return (
    <div className="modal-backdrop" onClick={onClose} data-testid={`${testId}-backdrop`}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()} data-testid={testId}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h3 className="text-base font-semibold" style={{ color: "var(--brand-navy)" }}>
            {title}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700"
            data-testid={`${testId}-close`}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>
        <div className="px-6 py-5">{children}</div>
        {footer && <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-2">{footer}</div>}
      </div>
    </div>
  );
}
